"use strict";

exports.__esModule = true;
exports.TOKEN = exports.QUERIES = void 0;
exports.getBreakpointWidth = getBreakpointWidth;
let QUERIES = exports.QUERIES = /*#__PURE__*/function (QUERIES) {
  QUERIES["MEDIUMMOBILE"] = "mediumMobile";
  QUERIES["LARGEMOBILE"] = "largeMobile";
  QUERIES["TABLET"] = "tablet";
  QUERIES["DESKTOP"] = "desktop";
  QUERIES["LARGEDESKTOP"] = "largeDesktop";
  return QUERIES;
}({});
const TOKEN = exports.TOKEN = {
  mediumMobile: "widthBreakpointMediumMobile",
  largeMobile: "widthBreakpointLargeMobile",
  tablet: "widthBreakpointTablet",
  desktop: "widthBreakpointDesktop",
  largeDesktop: "widthBreakpointLargeDesktop"
};
function getBreakpointWidth(name, theme, pure) {
  return pure ? theme.orbit[TOKEN[name]] : `(min-width: ${theme.orbit[TOKEN[name]]}px)`;
}